($ => {

    "use strict";

    $(document).ready(() => {
        const page = $(".page-autorizacao-palestrante");
        if (!page.length || !$("form", page).length) return;

        const modal = $(".modal-captura-foto");
        const video = document.querySelector("video#fotoCaptura");
        const canvas = document.querySelector("canvas#fotoTempResponsavel");
        let stream = null;

        // O termo repete o nome do responsável e a opção escolhida. Na carga, aplica direto (sem
        // disparar "change", que acionaria a validação e marcaria os campos vazios como erro).
        const nome = $("#nomeResponsavel", page);
        const status = $("#status", page);
        const atualizarNome = () => $("[data-autorizacao-nome]", page).text(nome.val().trim() || "nome do responsável");
        const atualizarTermo = () => {
            const valor = status.val();
            $("[data-autorizacao-termo]", page).prop("hidden", !valor);
            $("[data-autorizacao-acao]", page).text(valor === "DESAUTORIZADO" ? "NÃO AUTORIZO" : "AUTORIZO");
        };
        nome.on("input change", atualizarNome);
        status.on("change", atualizarTermo);
        atualizarNome();
        atualizarTermo();

        function pararCamera() {
            stream?.getTracks().forEach(track => track.stop());
            stream = null;
            video.srcObject = null;
        }

        $("[data-autorizacao-camera]", page).on("click", async function() {
            const erro = $("[data-autorizacao-camera-erro]", page).removeClass("show-error");
            try {
                stream = await navigator.mediaDevices.getUserMedia({ video: true });
                video.srcObject = stream;
                await video.play();
                modal.showModal();
            } catch (error) {
                pararCamera();
                erro.addClass("show-error");
                console.error(error);
            }
        });

        $("[data-autorizacao-capturar]", modal).on("click", function() {
            // Recorte quadrado central do vídeo
            const lado = Math.min(video.videoWidth, video.videoHeight);
            const x = (video.videoWidth - lado) / 2;
            const y = (video.videoHeight - lado) / 2;
            canvas.getContext("2d").drawImage(video, x, y, lado, lado, 0, 0, canvas.width, canvas.height);
            canvas.hidden = false;

            const foto = $("#fotoResponsavel", page);
            foto.val(canvas.toDataURL("image/png"));
            validateInputField(foto[0]);
            $("[data-autorizacao-camera-texto]", page).text("Tirar outra foto");
            modal.close();
        });

        modal.on("close", pararCamera);
    });

})(jQuery);
